import { useCallback } from 'react'
import { useCurrentOrg } from 'auth/hooks'
import { useCreateApiNotification } from 'civic-champs-shared/api/hooks'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import useSetSortOrder from 'core/table/table-hooks/useSetSortOrder'

export const useReorderRoles = (getRoles: () => {}) => {
  const [request] = useFetchRefactored<{ id: number }[]>({
    emptyValue: undefined,
  })

  const createNotification = useCreateApiNotification()
  const currentOrg = useCurrentOrg()
  const [setSortOrder] = useSetSortOrder()

  return useCallback(
    async ({ rows, sortOption }) => {
      const notification = createNotification('Reordering roles')
      try {
        await setSortOrder('roles', `"${sortOption.field}" ${sortOption.order}`)

        if (sortOption.isCustom) {
          // @ts-ignore
          await request({
            method: 'put',
            url: `/organizations/${currentOrg.id}/roles`,
            config: {
              body: rows.map(({ id }: any, index: number) => ({ id, order: index + 1 })),
            },
          })
        }

        await getRoles()

        notification.onSuccess('Roles reordered!')
      } catch (error) {
        notification.onError(`Could not reorder roles`, error)
      }
    },
    [createNotification, currentOrg.id, getRoles, request, setSortOrder],
  )
}

export default useReorderRoles
